import { render, staticRenderFns } from "./BaseChessOne.vue?vue&type=template&id=6800d0b6&scoped=true"
import script from "./BaseChessOne.vue?vue&type=script&lang=js"
export * from "./BaseChessOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800d0b6",
  null
  
)

export default component.exports